import { useState, type FormEvent } from "react";

type LoginScreenProps = {
  onLogin: () => void;
};

export const LoginScreen = ({ onLogin }: LoginScreenProps) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (username === "user" && password === "password") {
      setError(null);
      onLogin();
      return;
    }

    setError("Invalid username or password.");
  };

  return (
    <main className="min-h-screen bg-[#f8f9fb] px-6 py-12">
      <div className="mx-auto w-full max-w-md rounded-[32px] border border-[var(--stroke)] bg-white p-10 shadow-[var(--shadow)]">
        <div className="mb-8 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[var(--gray-text)]">
            Project Management MVP
          </p>
          <h1 className="mt-4 text-3xl font-semibold text-[var(--navy-dark)]">Sign in</h1>
          <p className="mt-3 text-sm text-[var(--gray-text)]">
            Use <span className="font-semibold">user</span> / <span className="font-semibold">password</span> to continue.
          </p>
        </div>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <label className="block text-sm font-medium text-[var(--navy-dark)]">
            Username
            <input
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              className="mt-2 w-full rounded-xl border border-[var(--stroke)] bg-[var(--surface)] px-4 py-3 text-sm outline-none transition focus:border-[var(--primary-blue)]"
              placeholder="user"
              autoComplete="username"
            />
          </label>

          <label className="block text-sm font-medium text-[var(--navy-dark)]">
            Password
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="mt-2 w-full rounded-xl border border-[var(--stroke)] bg-[var(--surface)] px-4 py-3 text-sm outline-none transition focus:border-[var(--primary-blue)]"
              placeholder="password"
              autoComplete="current-password"
            />
          </label>

          {error ? <div className="rounded-xl bg-[#ffe9e9] px-4 py-3 text-sm text-[#9f1c1c]">{error}</div> : null}

          <button
            type="submit"
            className="w-full rounded-full bg-[var(--secondary-purple)] px-4 py-3 text-sm font-semibold uppercase tracking-[0.2em] text-white transition hover:brightness-110"
          >
            Sign in
          </button>
        </form>
      </div>
    </main>
  );
};
